var _defs, _g, _path, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBetaTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41 26"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "beta-tag_svg__a",
    width: 63,
    height: 48,
    x: -11,
    y: -11,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceGraphic",
    result: "FeOffset1025Out"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "FeOffset1025Out",
    result: "FeGaussianBlur1026Out",
    stdDeviation: "2.4 2.4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "beta-tag_svg__b",
    width: 2,
    height: 2,
    x: -1,
    y: -1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 5h31v16H5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8.5a3 3 0 013-3h25a3 3 0 013 3v9a3 3 0 01-3 3H8a3 3 0 01-3-3z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#beta-tag_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M5 8.5a3 3 0 013-3h25a3 3 0 013 3v9a3 3 0 01-3 3H8a3 3 0 01-3-3z",
    mask: "url(\"#b\")"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3273fa",
    d: "M5 8.5a3 3 0 013-3h25a3 3 0 013 3v9a3 3 0 01-3 3H8a3 3 0 01-3-3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3273fa",
    d: "M5 8.5a3 3 0 013-3h25a3 3 0 013 3v9a3 3 0 01-3 3H8a3 3 0 01-3-3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.65 14.11c-.033 0-.047-.02-.04-.06l.625-2.24c.007-.02.017-.03.03-.03.013 0 .023.01.03.03l.635 2.24c.013.04 0 .06-.04.06zm-.87 2.39c.093 0 .15-.043.17-.13l.22-.78c.013-.027.03-.04.05-.04h2.12c.02 0 .037.013.05.04l.22.78c.02.087.077.13.17.13h1.71c.093 0 .14-.037.14-.11a.14.14 0 00-.01-.06l-2.11-6.71c-.027-.08-.083-.12-.17-.12h-2.12c-.087 0-.143.04-.17.12l-2.11 6.71c-.033.113.01.17.13.17zm-3.58 0a.149.149 0 00.11-.04.149.149 0 00.04-.11v-5.18c0-.033.017-.05.05-.05h1.68a.149.149 0 00.11-.04.149.149 0 00.04-.11V9.65a.149.149 0 00-.04-.11.149.149 0 00-.11-.04h-5.29a.149.149 0 00-.11.04.149.149 0 00-.04.11v1.32c0 .047.013.083.04.11.027.027.063.04.11.04h1.63c.033 0 .05.017.05.05v5.18c0 .047.013.083.04.11.027.027.063.04.11.04zm-4.13 0a.149.149 0 00.11-.04.149.149 0 00.04-.11v-1.31a.149.149 0 00-.04-.11.149.149 0 00-.11-.04h-2.99c-.033 0-.05-.017-.05-.05V13.8c0-.033.017-.05.05-.05h1.85a.149.149 0 00.11-.04.149.149 0 00.04-.11v-1.3a.149.149 0 00-.04-.11.149.149 0 00-.11-.04h-1.85c-.033 0-.05-.017-.05-.05v-.94c0-.033.017-.05.05-.05h2.99a.149.149 0 00.11-.04.149.149 0 00.04-.11V9.65a.149.149 0 00-.04-.11.149.149 0 00-.11-.04H15.3a.149.149 0 00-.11.04.149.149 0 00-.04.11v6.7c0 .047.013.083.04.11.027.027.063.04.11.04zm-9.14-1.61c-.033 0-.05-.017-.05-.05v-1.05c0-.033.017-.05.05-.05h.92c.467 0 .7.187.7.56 0 .393-.237.59-.71.59zm0-2.68c-.033 0-.05-.017-.05-.05v-1c0-.033.017-.05.05-.05h.82c.487 0 .73.183.73.55 0 .367-.243.55-.73.55zm.91 4.29c.767 0 1.39-.162 1.87-.485.48-.323.72-.828.72-1.515 0-.367-.07-.68-.21-.94a1.61 1.61 0 00-.66-.64c-.027-.02-.027-.04 0-.06.507-.287.76-.747.76-1.38 0-.713-.215-1.222-.645-1.525-.43-.303-1.072-.455-1.925-.455h-2.6a.149.149 0 00-.11.04.149.149 0 00-.04.11v6.7c0 .047.013.083.04.11.027.027.063.04.11.04z"
  }))));
}
export default __webpack_public_path__ + "static/_/shared/assets/svg/beta-tag.svg";
export { SvgBetaTag as ReactComponent };